import axios from 'axios'

export const login = (data) => {
  return axios.post('auth/login', data)
}

export const loginWithProvider = (info) => {
  return axios.post('/auth/login-provider', info)
}

export const register = (data) => {
  return axios.post('auth/register', data)
}

export const active = (data) => {
  return axios.post('auth/active-user', data)
}

export const forgotPassword = (data) => {
  return axios.post('auth/forget-password', data)
}

export const resetPassword = (data) => {
  return axios.post('auth/reset-password', data)
}

export const changePassword = (data) => {
  return axios.post('user/change-password', data)
}

export const resendEmailActive = (data) => {
  return axios.post('auth/resend-email', data)
}

export const updateProfile = (data) => {
  return axios.post('profile', data)
}

export const getProfile = (data) => {
  return axios.get('user/me', data)
}

export const getS3Credentials = () => {
  return axios.get('s3/token')
}



// WEBPACK FOOTER //
// ./src/api/account.js